import React, { useState } from "react";
const NEON = "#00FF99";

export default function RequestDetailsDrawer({ open, request, onClose, onApprove, onReject, onOverride }) {
  const [note, setNote] = useState("");
  if (!open || !request) return null;

  return (
    <div className="fixed inset-0 z-[10080]">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-full max-w-md bg-black border-l border-white/10 p-5 overflow-auto">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold" style={{ color: NEON }}>{request.id} — {request.employeeName}</h3>
          <button onClick={onClose} className="text-white/60 hover:text-white">✕</button>
        </div>

        <div className="space-y-2 text-sm">
          <Row k="Employee ID" v={request.employeeId} />
          <Row k="Department"  v={request.dept} />
          <Row k="Type"        v={request.type} />
          <Row k="Dates"       v={`${request.startDate} → ${request.endDate} (${request.days} day(s))`} />
          <Row k="Status"      v={request.status} />
        </div>

        <div className="mt-4">
          <p className="text-white/70 text-sm mb-1">Conflicts</p>
          <div className="flex flex-wrap gap-2">
            {request.conflicts?.blackout && <Chip>Blackout</Chip>}
            {request.conflicts?.staffingBelow && <Chip>Staffing risk</Chip>}
            {request.conflicts?.teamOff > 0 && <Chip>{request.conflicts.teamOff} overlap</Chip>}
            {!request.conflicts && <span className="text-white/50 text-sm">None</span>}
          </div>
        </div>

        <div className="mt-4">
          <p className="text-white/70 text-sm mb-1">Notes</p>
          <div className="space-y-1 text-xs text-white/70">
            {(request.notes || []).map((n,i)=> <div key={i}>• {n.text} <span className="text-white/40">({n.by}, {n.at})</span></div>)}
          </div>
          <div className="mt-2 flex gap-2">
            <input value={note} onChange={e=>setNote(e.target.value)} placeholder="Add a note"
              className="flex-1 bg-black/30 border border-white/10 rounded-xl px-3 py-1.5 text-sm text-white" />
            <button onClick={()=>onApprove?.(request.id, note)} className="text-xs px-3 py-1.5 rounded-full border border-white/10 bg-white/10 hover:bg-white/20">Approve</button>
            <button onClick={()=>onReject?.(request.id, note)}  className="text-xs px-3 py-1.5 rounded-full border border-white/10 bg-white/10 hover:bg-white/20">Reject</button>
            <button onClick={()=>onOverride?.(request.id, note)} className="text-xs px-3 py-1.5 rounded-full border" style={{ backgroundColor:"rgba(239,68,68,0.15)", borderColor:"rgba(239,68,68,0.35)" }}>Override</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Row({ k, v }) {
  return <div className="flex justify-between text-white/80"><span className="text-white/60">{k}</span><span>{v}</span></div>;
}
function Chip({ children }) {
  return <span className="text-[11px] px-2 py-0.5 rounded-full border" style={{ color: NEON, backgroundColor: "rgba(0,255,153,0.12)", borderColor: "rgba(0,255,153,0.35)" }}>{children}</span>;
}
